import axios from "axios";
import { API_URL } from "src/scenes/App";

const getBrowserCountryCode = () => {
    const browserLocale = typeof navigator !== "undefined"
        ? navigator.languages?.[0] || navigator.language || ""
        : "";
    const locale = Intl.DateTimeFormat().resolvedOptions().locale || browserLocale;

    try {
        const countryCode = new Intl.Locale(locale).region;
        if (countryCode) {
            return countryCode.toUpperCase();
        }
    } catch {
        // Fall back to parsing below for browsers without full Intl.Locale support.
    }

    const match = locale.match(/[-_]([A-Za-z]{2})(?:$|[-_])/);
    return match ? match[1].toUpperCase() : null;
};

export const updateFeatureLevel = async (featureLevel, userTimeZone, token) => {
    try {
        const countryCode = getBrowserCountryCode();
        const response = await axios.put(`${API_URL}/employee/appEnvironment`, {
            featureLevel: featureLevel,
            timezone: userTimeZone,
            ...(countryCode ? { countryCode } : {})
        }, {
            headers: {
                Authorization: "Bearer " + token
            }
        });
        return response.data;
    } catch (e) {
        return console.warn("Unable to request update for user feature level.", e);
    }
};
